<template>
  <div class="py-4 container-fluid">
    <div class="custom-header font-weight-bold text-left">{{ titleCase(this.getHotelName) }} Booked List</div>
    <div class="card mb-4">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-md-6 text-left">
                    <label for="crewStatus" class="font-weight-bold">Select Crew :</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <i class="fa fa-search pr-2"></i>By All:
                        </button>

                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':params.searchKey == 'all'}">All</a>
                          <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':params.searchKey == 'last_name'}">LastName</a>
                          <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':params.searchKey == 'first_name'}">FirstName</a>
                          <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':params.searchKey == 'middle_name'}">MiddleName</a>
                          <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':params.searchKey == 'rank'}">Rank</a>
                          <a class="dropdown-item" href="#" @click="setKey('crewipn')" :class="{'active':params.searchKey == 'crewipn'}">CrewIPN</a>
                        </div>
                      </div>

                      <input type="text"
                             id="crewStatus"
                             class="form-control form-control-sm"
                             v-model="params.searchValue"
                             v-on:input="searchCrew(1)"
                             :placeholder="keyPlaceHolder"
                             aria-label="Text input with dropdown button">
                    </div>
                  </div>

                  <div class="col-md-2 text-left">
                    <label for="rsvStatus" class="font-weight-bold">Status :</label>
                    <select name="rsvStatus" id="rsvStatus" class=" custom-select custom-select-sm" v-on:change="setStatus">
                      <option :value="''">All</option>
                      <option v-for="(status,index) in reservationStatus" :key="index" :value="index+1">
                        {{ status[index] }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-2 text-left">
                    <label for="displayCounts" class="font-weight-bold">Records:</label>
                    <select class="custom-select custom-select-sm" id="displayCounts" v-model="params.count" v-on:change="setRecords">
                      <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === params.count">
                        {{ count }} records
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body fs-13px">
        <div class="text-left">
          <small>
            {{ `${tnkcBookedPaganation.from} - ${tnkcBookedPaganation.to} of ${tnkcBookedPaganation.total}` }}</small>
        </div>
        <nav aria-label="..." class="pt-2">
          <ul class="pagination pagination-sm">
            <li class="page-item" :class="{ 'disabled': tnkcBookedPaganation.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">
                <font-awesome-icon icon="step-backward"/>
                First
              </button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === tnkcBookedPaganation.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': tnkcBookedPaganation.currentPage === tnkcBookedPaganation.lastPage}">
              <button class="page-link" @click="setPage(tnkcBookedPaganation.lastPage)">
                Last
                <font-awesome-icon icon="step-forward"/>
              </button>
            </li>
          </ul>
        </nav>
        <div class="table-responsive-sm">
          <table class="table table-bordered" width="100%" cellspacing="0">
            <thead>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center">
                <button id="reset" class="btn btn-sm tnkc-secondary" @click="refresh" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                  <font-awesome-icon icon="undo"/>
                </button>
              </th>
            </tr>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center" width="15px">#</th>
              <th scope="col" class="p-1">Rank</th>
              <th scope="col" class="p-1">Crew</th>
              <th scope="col" class="p-1">Floor —> Room —> Bed</th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm" v-on:click="sortByCheckIn('check_in',sorting)">
                  <span class="font-weight-bold">Check In</span>
                  <sup class="ml-1" v-if="sList.sortCheckIn == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortCheckIn" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortCheckIn" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm " @click="sortByCheckOut('booked_check_out',sorting)">
                  <span class="font-weight-bold">Check Out</span>
                  <sup class="ml-1" v-if="sList.sortCheckOut == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortCheckOut" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortCheckOut" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">Extend</th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm font-weight-bold" @click="sortByDays('days_stayed',sorting)">
                  <span class="font-weight-bold">#Days</span>
                  <sup class="ml-1" v-if="sList.sortDays == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortDays" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortDays" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">Status</th>
              <th scope="col" class="p-1" colspan="3">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(booking, index) in bookings" :key="booking.booking_id" v-bind:class="bookedExpired(booking)">
              <th scope="row" class="p-1 align-middle">{{ index + 1 }}</th>
              <td class="p-1 align-middle">{{ booking.rank }}</td>
              <td class="p-1 align-middle text-left">
                <button class="btn btn-xsm" v-on:click="viewProfile(booking.crew_id)">
                  <u>{{ booking.crew }}</u>
                </button>
              </td>
              <td class="p-1 align-middle vert-aligned">{{ booking.floor }}—{{ booking.room }}—{{ booking.bed }}</td>
              <td class="p-1 align-middle ">
                {{ booking.check_in | moment('D MMM YYYY') }}
              </td>

              <td class="p-1 align-middle">
                <sup v-if="booking.booked_date_extend" class="ml-1">
                  <font-awesome-icon icon="arrows-alt-h"/>
                </sup>
                {{ booking.check_out | moment('D MMM YYYY') }}
              </td>
              <td> {{ booking.booked_date_extend | moment('D MMM YYYY') }}</td>
              <td class="p-1 align-middle" style="width: 7% !important;">{{ booking.days_stayed }}</td>
              <td class="p-1 align-middle" style="width: 7% !important;">{{ booking.status }}</td>
              <td class="p-1 align-middle vert-aligned">
                <button type="button" class="btn btn-xsm tnkc-primary" @click="viewProfile(booking.crew_id)">
                  <font-awesome-icon icon="eye"/>
                  View
                </button>

                <!-- action checkout button -->
                <div class="btn-group dropleft ml-1" v-if="booking.is_checkIn && !booking.is_checkOut">
                  <button type="button" class="btn btn-xsm tnkc-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="small"> Action</span>
                  </button>

                  <div class="dropdown-menu p-1 w-25">
                    <button type="button" class="btn btn-xsm tnkc-secondary dropdown-item text-left"
                            data-toggle="modal"
                            data-target="#actionRemarksModal"
                            data-backdrop="static"
                            data-keyboard="false"
                            v-on:click="setActionType(booking,2)">
                      <font-awesome-icon icon="sign-out-alt" class="ml-4"/>
                      <span class="ml-2 small">CHECK-OUT</span>
                    </button>
                    <button type="button" class="btn btn-xsm tnkc-danger dropdown-item text-left mt-1"
                            data-toggle="modal"
                            data-target="#transferModal"
                            data-backdrop="static"
                            data-keyboard="false"
                            v-on:click="setActionType(booking,0)">
                      <font-awesome-icon icon="exchange-alt" class="ml-4"/>
                      <span class="ml-2 small">TRANSFFER</span>
                    </button>
                  </div>
                </div>

                <button type="button" class="btn btn-xsm tnkc-success ml-1"
                        v-if="!booking.is_checkIn"
                        data-toggle="modal"
                        data-target="#actionRemarksModal"
                        data-backdrop="static"
                        data-keyboard="false"
                        v-on:click="setActionType(booking,1)">
                  <font-awesome-icon icon="sign-in-alt"/>
                  <small class="font-weight-bold ml-1">Check-in</small>
                </button>

                <!--                                <button type="button" class="btn btn-xsm tnkc-secondary ml-1"-->
                <!--                                        data-toggle="modal"-->
                <!--                                        data-target="#actionRemarksModal"-->
                <!--                                        data-backdrop="static"-->
                <!--                                        data-keyboard="false"-->
                <!--                                        v-if="booking.check_in != null && booking.check_out == null && hotelId == 1"-->
                <!--                                        v-on:click="setActionType(booking,2)">-->
                <!--                                    <font-awesome-icon icon="sign-out-alt"/>-->
                <!--                                    <small class="font-weight-bold ml-1">Check-out</small>-->
                <!--                                </button>-->

                <button type="button" class="btn btn-xsm tnkc-warning ml-1"
                        v-if="booking.is_extend && !booking.is_checkOut"
                        data-toggle="modal"
                        data-target="#actionRemarksModal"
                        data-backdrop="static"
                        data-keyboard="false"
                        v-on:click="setActionType(booking,3)">
                  <font-awesome-icon icon="arrows-alt-h"/>
                  <small class="font-weight-bold ml-1">Extend</small>
                </button>

                <!--                                <button type="button" class="btn btn-xsm tnkc-secondary ml-1" >-->
                <!--                                    <font-awesome-icon icon="exchange-alt"/>-->
                <!--                                    <small class="font-weight-bold ml-1">Transfer</small>-->
                <!--                                </button>-->

                <button type="button" class="btn btn-xsm tnkc-danger ml-1"
                        v-if="booking.is_active && !booking.is_checkIn"
                        v-on:click="bookedCancel(booking)">
                  <font-awesome-icon icon="ban"/>
                  <small class="font-weight-bold ml-1">Cancel</small>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <action-remarks
        :checkedIn="bookedCheckIn"
        :checkedOut="bookedCheckOut"
        :extend="bookedExtend"
        :checkConflict="checkSchedConflict"
        :action-type="actionType"/>


    <!-- transfer modal -->
    <transfer-modal :search="searchCrew"/>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import ActionRemarks from './_modals/actionRemarks';
import {appMixins} from '../../mixins/app.mixins';
import TransferModal from './_modals/transfferModal';

export default {
  name: 'BookingList',
  mixins: [appMixins],
  props: ['hotelId', 'code', 'name'],
  data() {
    return {
      requestTitle: '',

      displayCounts: [2, 5, 10, 15, 20, 30, 50, 100, 200],

      //+1 for index value
      reservationStatus: [
        {0: 'Booked'},
        {1: 'Checked In'},
        {2: 'Checked Out'},
        {3: 'Extended'},
        {4: 'Over-Stay'},
      ],

      params: {
        page: '',
        searchValue: '',
        searchKey: 'all', //default
        count: 10,
        hotel_id: this.hotelId,
        status : ''
      },

      bookingId: '',
      reservationId: '',
      actionType: 0,

      //for batch
      value: null,
      sorting: false,

      sList: {
        // sortBatch: null,
        // sortRank: null,
        sortName: null,
        // sortRoom: null,
        // sortBuildings: null,
        sortCheckIn: null,
        sortCheckOut: null,
        sortDays: null,
        // sortRemarksCount: null,
      },
    };
  },

  components: {
    ActionRemarks,
    TransferModal,
  },

  methods: {
    ...mapActions([
      'getBookedListByHotel',
      'getBookedDetails',
      'setNewBookingNull',
      'setBookedNull',
      'getBookedDetails',
      'setCheckInOrOut',
      'setExtendDate',
      'checkConflict',
      'deleteBooking',
      'setBookingsNull',
      'setNullNewRemark',
      'setResetTnkcBookedPagination',
    ]),

    viewProfile(id) {
      this.$router.push({name: 'CrewProfile', params: {id: id}});
    },

    //todo
    viewReservationDetails() {},

    remarksOnAction(title) {
      this.requestTitle = title;
    },

    async searchCrew(initializePage = null) {
      let page = (initializePage) ? initializePage : this.tnkcBookedPaganation.currentPage;
      this.params.page = page;
      this.params.batch_id = this.value ? this.value.id : '';
      await this.getBookedListByHotel(this.params);
    },
    //key
    setKey(obj) {
      this.params.searchKey = obj;
      this.searchBy();
      this.searchCrew();
      this.resetSList();
    },

    //page
    setPage(page) {
      this.tnkcBookedPaganation.currentPage = page;
      this.searchCrew();
      // this.resetSList();
    },

    setRecords(e) {
      this.params.count = parseInt(e.target.value, 10);
      this.searchCrew(1);
      // this.resetSList();
    },

    searchBy() {
      switch (this.params.searchKey) {
        case 'all':
          this.key = 'All';
          this.keyPlaceHolder = 'Search here ...';
          break;

        case 'last_name':
          this.key = 'LastName';
          this.keyPlaceHolder = 'Search Last Name here ...';
          break;

        case 'first_name':
          this.key = 'FirstName';
          this.keyPlaceHolder = 'Search First Name here ...';
          break;

        case 'middle_name':
          this.key = 'MiddleName';
          this.keyPlaceHolder = 'Search Middle Name here ...';
          break;

        case 'crewipn':
          this.key = 'CrewIPN';
          this.keyPlaceHolder = 'Search CrewIPN here ...';
          break;

        case 'rank':
          this.key = 'Rank';
          this.keyPlaceHolder = 'Search CrewRank here ...';
          break;
      }
    },

    sortByData(sortKey, orderBy) {
      const bookingList = this.bookings;
      this.sorting = !this.sorting;
      bookingList.sort((a, b) => {
        let compare = 0;
        if (orderBy == true) {
          if (a[sortKey] < b[sortKey]) {
            compare = 1;
          } else if (b[sortKey] < a[sortKey]) {
            compare = -1;
          }
          return compare;

        } else if (orderBy == false) {
          if (a[sortKey] > b[sortKey]) {
            compare = 1;
          } else if (b[sortKey] > a[sortKey]) {
            compare = -1;
          }
          return compare;
        }
      });
    },

    sortFlag: function(val) {
      let obj = null;
      if (val == null) {
        obj = true;
      } else if (val == true) {
        obj = false;
      } else if (val == false) {
        obj = true;
      }
      return obj;
    },

    sortByName(key, sorting) {
      this.sList.sortName = this.sortFlag(this.sList.sortName);
      this.sortByData(key, sorting);
    },

    sortByCheckIn(key, sorting) {
      let sortKey = key ? key : 'check_in';  //booked_check_in change to check_in
      this.sList.sortCheckIn = this.sortFlag(this.sList.sortCheckIn);
      this.sortByData(sortKey, sorting);
    },

    sortByCheckOut(key, sorting) {
      let sortKey = key ? key : 'check_out'; //booked_check_out change to check_out
      this.sList.sortCheckOut = this.sortFlag(this.sList.sortCheckOut);
      this.sortByData(sortKey, sorting);
    },

    sortByDays(key, sorting) {
      this.sList.sortDays = this.sortFlag(this.sList.sortDays);
      this.sortByData(key, sorting);
    },

    resetSList(val) {
      let sortCarretTrigger = this.sList;
      let except = val ? val : '';
      for (let prop in sortCarretTrigger) {
        if (sortCarretTrigger.hasOwnProperty(prop)) {
          sortCarretTrigger[prop] = null;
        } else if (except) {
          if (prop == except) {
            sortCarretTrigger[prop] = sortCarretTrigger[prop];
          }
        }
      }
    },

    refresh() {
      this.resetSList();
      this.searchCrew();
    },

    setActionType(data, type) {
      this.bookingId = data.booking_id;
      this.reservationId = data.reservation_id;
      this.actionType = type;
      this.bookedDetails(data.booking_id);
    },

    bookedDetails(id) {
      this.getBookedDetails(id);
    },

    bookedCheckIn() {
      const params = {
        booking_id: this.bookingId,
        crew_reservation_id: this.reservationId,
        remarks: this.newRemarks,
        checking_in: true,
      };
      this.setCheckInOrOut(params).then((res) => {
        if (res == true) {
          this.successAlert('Check-In successfully');
          this.searchCrew();
          this.setNullNewRemark();
        }
      });
    },

    bookedCheckOut() {
      const params = {
        booking_id: this.bookingId,
        crew_reservation_id: this.reservationId,
        remarks: this.newRemarks,
        checking_in: false,
      };

      this.setCheckInOrOut(params).then((res) => {
        if (res == true) {
          this.successAlert('Check-Out successfully');
          this.searchCrew();
          this.setNullNewRemark();
        }
      });
    },

    async bookedExtend() {
      this.booked.remarks = this.newRemarks;
      if (await this.questionAlert('Are you sure you want to extend this booked sched?')) {
          await this.setExtendDate(this.booked);
      }
    },

    checkSchedConflict() {
     return this.checkConflict(this.booked);
    },

    async bookedCancel(obj) {
      if (await this.questionAlert('Are you sure you want to cancelled this booked.')) {
        await this.deleteBooking(obj);
      }
    },

    bookedExpired(obj) {
      if (obj.is_overStayed && !obj.is_checkOut) {
        return 'tnkc-danger';
      }
      return '';
    },

    setStatus(e) {
      this.params.status = e.target.value;
      this.searchCrew(1);
    },
  },

  computed: {
    ...mapGetters(['tnkcBookedPaganation', 'bookings', 'booked', 'newRemarks', 'remarks']),

    paginationPages() {
      let pages = [];
      let currentPage = this.tnkcBookedPaganation.currentPage;
      let lastPage = this.tnkcBookedPaganation.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },

    getHotelName() {
      return this.name ? this.name : localStorage.getItem('HOTEL_NAME');
    },
  },

  watch: {
    name: function(props_name) {
      localStorage.setItem('HOTEL_NAME', props_name);
      // console.log('blobbb moving .',props_name);
    },
    hotelId: function(props_hotelId) {
      this.params.hotel_id = props_hotelId;
      this.getBookedListByHotel(this.params);
    },
  },

  created() {
    this.searchBy();
    this.searchCrew();
  },

  mounted() {
    //todo
    $(function() {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
      });
    });
  },

  destroyed() {
    this.setBookingsNull();
    // localStorage.removeItem('HOTEL_NAME');
    this.setResetTnkcBookedPagination();
  },
};
</script>

<style scoped>
u:hover,
u:focus {
  color: #2c82c9 !important;
  color: #4a4f54;
}

.table tbody > tr > td.vert-aligned {
  vertical-align: middle;
  padding: 0 !important;
}

.btn-xsm, .btn-group-xsm > .btn {
  padding: 0.20rem 0.2rem !important;
  font-size: 0.870rem !important;
  line-height: 1 !important;
  border-radius: 0.25rem !important;
}

.h-400px {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

table {
  margin-bottom: 0;
}

.modal-header * {
  font-weight: bold;
}

.modal-body {
  padding: 0 1rem;
}

#transfer .h-400px {
  height: 200px;
}

.pagination li {
  margin: 0;
}

.fs-13px {
  font-size: 13px;
}

.btn-view-container {
  text-align: right;
  width: 75px;
  border-right: 0px solid;
}

.btn-check-container {
  width: 100px;
  border-left: 0px solid;
  border-right: 0px solid;
}

.btn-extend-container {
  text-align: left;
  width: 90px;
  border-left: 0px solid;
}

</style>
